import { render, staticRenderFns } from "./InvoiceRelationBadge.vue?vue&type=template&id=9ffae658&scoped=true&"
import script from "./InvoiceRelationBadge.vue?vue&type=script&lang=ts&"
export * from "./InvoiceRelationBadge.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceRelationBadge.vue?vue&type=style&index=0&id=9ffae658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffae658",
  null
  
)

export default component.exports